import { cn } from '@/lib/utils';

interface SkeletonTableProps {
  rows?: number;
  cols?: number;
  className?: string;
}

export function SkeletonTable({ rows = 5, cols = 4, className }: SkeletonTableProps) {
  return (
    <div className={cn('w-full', className)}>
      {/* Header row */}
      <div className="flex gap-4 px-4 py-3 border-b border-border">
        {Array.from({ length: cols }).map((_, i) => (
          <div key={i} className="h-3 bg-muted animate-pulse rounded flex-1" />
        ))}
      </div>
      {/* Data rows */}
      {Array.from({ length: rows }).map((_, rowIdx) => (
        <div key={rowIdx} className="flex gap-4 px-4 py-3 border-b border-border last:border-0">
          {Array.from({ length: cols }).map((_, colIdx) => (
            <div
              key={colIdx}
              className={cn(
                'h-4 bg-muted animate-pulse rounded flex-1',
                colIdx === 0 && 'max-w-[120px]',
                colIdx === cols - 1 && 'max-w-[80px]',
              )}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
